import React, { useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';

import Header from '../../components/Header';
import Footer from '../../components/Footer';

import '../../assets/styles/globals.css';
import './styles.css';

import cmsImg from '../../assets/images/turbine.png';
import cmsImg2 from '../../assets/images/windintelli/highlights-4.png';


function CMS() {

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
    })
  }, [])

  return (
    <>
      <Header />
      <div className="background-pms">
        <div className="bg-pms"></div>
        <div className="container">
          <div className="banner-pms content-pms">
            <h1>CMS</h1>
            <p>Condition Monitoring System</p>
           </div>
        </div>
      </div>

      <div className="container">
        <div className="content gap-40 section-title">
          <h1>CMS</h1>
          <p className="pms-text">
          Eólica Tecnologia has a Vibration-based Condition Monitoring System (CMS) on all wind turbines. 
          The targets of the system are reduction of maintenance costs, increase of availability, avoidance of unplanned downtimes, improvement of quality & reliability and extend wind turbine’s lifetime.
          </p>
        </div>
      </div>

      <div className="container">
        <div className="content">
          <div className="pms-highlights">
            <Container>
              <Row>
                <Col xs={12} md={12} sm={12} lg={6} ><img src={cmsImg} alt="WindIntelli" className="right-40-padding"/></Col>
                <Col xs={12} md={12} sm={12} lg={6} className="col-pms-highlights left-40-padding">
                  <p>
                    Wind farms are unlike conventional power stations, the turbines are exposed to harsh weather conditions, including severe winds, high temperature, lightning and thunderstorms. 
                    Due to these external operational conditions, the wind turbines suffer constantly intense mechanical stress with a highly variable operation conditions (speed, load, etc.). 
                    Therefore, a high degree of maintenance is required to provide a safe, cost-effective and reliable power output.
                  </p>
                </Col>
              </Row>
            </Container>
          </div>  
        </div>
      </div>

      <div className="container">
        <div className="content">
          <div className="pms-highlights">
            <Container>
              <Row>
                <Col xs={12} md={12} sm={12} lg={6} className="col-pms-highlights right-40-padding">
                  <p>
                    Futhermore, Eólica Tecnologia has developed its own online system to treat and analyze automatically a large database from specific vibration data for all main components of the wind turbine. 
                    It works in three main steps: data acquisition using 8 sensors per turbine, signal processing/analysis with various techniques, and daily tracking/diagnosis. 
                    The system is also capable of generating reports and alarms identifying the fault and its location, maximizing reliability of Eólica Tecnologia’s wind farms.
                  </p>
                </Col>
                <Col xs={12} md={12} sm={12} lg={6} ><img src={cmsImg2} alt="WindIntelli" className="left-40-padding"/></Col>
              </Row>
            </Container>
          </div>  
        </div>
      </div>

        <Footer />
    </>
  )
}

export default CMS;